var lineItemComparePrice;
var cartObject;
/* currency formatter */
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});
$(document).ready(function ($) {
  /*
      On page load check if no items - show No items in cart else show the line  items
      */
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js-show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /* Remove Mni cart from the cart page as they have the same classes which picks double text and breaks the complete code */
  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $(".js-ajax-products-bind").remove();
    $("#cart-expand").removeClass("js-cart-expand");
    $("#cart-expand").attr("href", "/cart");
    reloadAjaxCartItems();
  } else {
    reloadAjaxCartItems();
    addAddonsToTheListInMiniCart();
  }
});
function minusQuantity(cartThis) {
  // debugger;
  let lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  let itemPrice = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-raw-line-item-price")
    .text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  let lineItemComparePrice = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-raw-item-compare-price")
    .text()
    .replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  let variantID = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find("input[name='updates[]']")
    .val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity - 1;
  $("input[name='updates[]']")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .val(newQuantity);
  if (newQuantity < 1) {
    removeCartItem("", lineItemCount, variantID);
  } else {
    CartJS.updateItem(
      lineItemCount,
      newQuantity,
      {},
      {
        success: function (data, textStatus, jqXHR) {

          if(typeof window.BOLD !== 'undefined'
             && typeof window.BOLD.common !== 'undefined'
             && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            data = window.BOLD.common.cartDoctor.fix(data);
          }
          
          //update the line_price and total
          bindLineItemData(
            variantID,
            lineItemComparePrice,
            itemPrice,
            newQuantity,
            lineItemCount
          );
          
          if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
            BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
          }
          
        },
        error: function (jqXHR, textStatus, errorThrown) {
          //console.log("Error: " + errorThrown + "!");
        },
      }
    );
    /*
    if you want to update item by ID and not by line item then you can use updateItemId function
    Recommended - line item update
    CartJS.updateItemById(lineIndex, newQuantity);
    */
  }
}
function plusQuantity(cartThis) {
  let lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  let itemPrice = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-raw-line-item-price")
    .text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  let lineItemComparePrice = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-raw-item-compare-price")
    .text()
    .replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  let variantID = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js-cart-table-item-row ")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find("input[name='updates[]']")
    .val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity + 1;
  $("input[name='updates[]']")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .val(newQuantity);
  CartJS.updateItem(
    lineItemCount,
    newQuantity,
    {},
    {
      success: function (data, textStatus, jqXHR) {
        
        if(typeof window.BOLD !== 'undefined'
           && typeof window.BOLD.common !== 'undefined'
           && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          data = window.BOLD.common.cartDoctor.fix(data);
        }
        
        //update the line_price and total\
        //debugger;
        bindLineItemData(
          variantID,
          lineItemComparePrice,
          itemPrice,
          newQuantity,
          lineItemCount
        );
        

        if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
          BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
        }
        
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //console.log("Error: " + errorThrown + "!");
      },
    }
  );
  //CartJS.updateItemById(lineIndex, newQuantity);
}
function bindLineItemData(
  variantID,
  lineItemComparePrice,
  itemPrice,
  newQuantity,
  lineItemCount
) {
  //debugger;
  /* Bind just the line with the new data which was changed */
  itemPrice = itemPrice / 100;
  itemPrice = itemPrice * newQuantity;
  itemPrice = formatter.format(itemPrice);
  /* Set the item price and attribute*/
  $(".cart-table-body")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-set-line-item-price")
    .text(itemPrice);
  $(".cart-table-body")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-set-line-item-price")
    .attr("data-attr-price", itemPrice);
  //set the new compared price in text and attribute
  lineItemComparePrice = lineItemComparePrice * newQuantity;
  lineItemComparePrice = lineItemComparePrice / 100;
  lineItemComparePrice = formatter.format(lineItemComparePrice);
  $(".cart-table-body")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-set-line-item-price")
    .attr("data-attr-compare-price", lineItemComparePrice);
  $(".cart-table-body")
    .filter('[data-cart-line-count="' + lineItemCount + '"]')
    .find(".js-set-compare-price")
    .text(lineItemComparePrice);
  /* Calculate total*/
  calculateSubTotal();
}
function removeCartItem(cartThis, lineItemCount, variantID) {
  //debugger;
  var lineItemCount;
  var ajaxLineItemVariantID;
  if (cartThis != "") {
    lineItemCount = $(cartThis).attr("data-cart-line-count");
    ajaxLineItemVariantID = $(cartThis).attr("data-cart-remove-variant");
  } else {
    ajaxLineItemVariantID = variantID;
  }
  CartJS.removeItem(lineItemCount, {
    success: function (data, textStatus, jqXHR) {

      if(typeof window.BOLD !== 'undefined'
         && typeof window.BOLD.common !== 'undefined'
         && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        data = window.BOLD.common.cartDoctor.fix(data);
      }

      /* For the cart page */
      /* If the mini cart is opened on the cart page, then 
                remove the line items from the cart page and update information again
                sub total/discount/total */
      if (
        $('.cart-table-body[data-cart-line-count="' + lineItemCount + '"]')
          .length
      ) {
        $(".cart-table-body")
          .filter('[data-cart-line-count="' + lineItemCount + '"]')
          .remove();
      }
      /*emtpy the UL items to re-bind them*/
      reloadAjaxCartItems(data, "action");

      if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
      }
      
    },
    error: function (jqXHR, textStatus, errorThrown) {
      /*//console.log('Error: ' + errorThrown + '!'); */
    },
  });
}
/* Reload Ajax cart items
        Data = After Success
        Else; on page load from cartjs object
        */
function reloadAjaxCartItems(data, action) {
  //debugger;
  if (action != undefined) {
    reloadAjaxCartItemUsingCartAjaxObject(data);
  } else {
    if ($ && $.getJSON && BOLD.common) {
      /* 
      ONLY IF BOLD OPTION IS ENABLED ON THE THEME
      This Code inside IF is only used if you have BOLD options enabled on the website
      if you don't have it then you can delete the complete IF statement
      */
      $.getJSON("/cart.js", function (data) {
        // BOLD.common.cartDoctor.cart is out of date in regards to any AJAX calls, which is why the cart was always a call behind
        //By making the reloadAjaxCartItems function use a getJSON we can be sure we are using a proper cart every time after a call/update.
        var lineCount = 1;
        cartObject = window.BOLD.common.cartDoctor.fix(data);
        $("#CartSidebar .js-ajax-products-bind").html("");
        $(cartObject.items).each(function () {
          var imageURL = this.featured_image.url;
          var itemPrice = this.original_price;
          var handle = this.handle;
          var itemID = this.id;
          itemPrice = itemPrice / 100;
          itemPrice = formatter.format(itemPrice);
          /* Bind the properties */
          let itemProperties = this.properties;
          let itemPropertiesElement;
          let itemPropertiesMainElement;
          itemPropertiesElement = "<ul>";
          $.each(itemProperties, function (key, value) {
            if (key.indexOf("_") > -1) {
            } else {
              itemPropertiesElement += "<li><span>" + key + ": </span>";
              itemPropertiesElement += "<li><span>" + value + "</span>";
              itemPropertiesElement += "</li>";
            }
          });
          itemPropertiesMainElement = itemPropertiesElement + "</ul>";
          /* check if variantTitle is NULL, then don't show variant */
          var variantTitle = this.variant_title;
          if (variantTitle == null) {
            variantTitle = "";
          }
          var lineItem;
          lineItem =
            '<li class="flex-wrap js-cart-table-item-row" data-cart-line-count=' +
            lineCount +
            ' data-handle="' +
            handle +
            '" data-variant-id=' +
            itemID +
            '><div class="image-section"> <a href="' +
            this.url +
            '"><img src="' +
            imageURL +
            '""> </a> </div>';
          lineItem +=
            '<div class="content"><h3><a href="' +
            this.url +
            '">' +
            this.product_title +
            "</a></h3><div class='cart_item_properties'>" +
            itemPropertiesElement +
            "</div>"; // lineItem += '<p class="capitalize">' + variantTitle + "</p>";
          lineItem +=
            '<div class="flex-space-between"><div class="cart-quantity-outer"> <a class="minus-qty" data-cart-line-count=' +
            lineCount +
            '" onclick="minusQuantity(' +
            lineCount +
            ')" data-variant-id=' +
            itemID +
            ' ></a> <input type="text" data-cart-line-count=' +
            lineCount +
            ' class="cart__quantity-selector" name="updates[]" value="' +
            this.quantity +
            '" maxlength="3" size="3"> <a class="plus-qty" data-cart-line-count=' +
            lineCount +
            ' onclick="plusQuantity(' +
            lineCount +
            ')" data-variant-id=' +
            itemID +
            "></a> </div>";
          lineItem +=
            "<div class='text-right'><p class='js-raw-line-item-price'>" +
            itemPrice +
            "</p>";
          lineItem +=
            '<div class="remove js-cart-item-remove" onclick="removeCartItem(this)" data-cart-remove-variant="' +
            this.id +
            '" data-cart-line-count=' +
            lineCount +
            ">Remove</div></div></div>";
          lineItem += "</li>";
          $("#CartSidebar .js-ajax-products-bind").append(lineItem);
          /* Update the Quantity and Compare Price Total for the line item if on the cart page */
          var lineItemComparePrice = $(
            ".cart-table-body[data-variant-id=" + itemID + "]"
          ).attr("data-attr-compare-price");
          lineItemComparePrice = lineItemComparePrice * this.quantity;
          lineItemComparePrice = lineItemComparePrice / 100;
          lineItemComparePrice = formatter.format(lineItemComparePrice);
          $(".cart-table-body")
            .filter('[data-variant-id="' + itemID + '"]')
            .find(".js-set-compare-price")
            .text(lineItemComparePrice);
          lineCount++;
        });
        /* Show and hide empty cart depending upon the cart items */
        setTimeout(function () {
          calculateSubTotal();
        }, 2000);
      });
      if (
        window.BOLD &&
        BOLD.common &&
        BOLD.common.eventEmitter &&
        typeof BOLD.common.eventEmitter.emit === "function"
      ) {
        BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", cartObject);
      }
    } else {
      //debugger;
      reloadAjaxCartItemUsingCartAjaxObject(data);
    }
  }
}
/*
USED TO RELOAD THE AJAX MINI CART
*/
function reloadAjaxCartItemUsingCartAjaxObject(data) {
  //console.log(data);
  var lineCount = 1;
  var cartObject;
  if (data == "undefined") {
    //console.log("No data is passed");
    cartObject = CartJS.cart;
  } else {
    //console.log("Data is passed");
    cartObject = data;
  }
  //console.log(cartObject); //console.log(BOLD.common.cartDoctor.cart.items);
  //console.log(cartObject.items);
  $("#CartSidebar .js-ajax-products-bind").html("");
  $(cartObject.items).each(function () {
    //console.log("Loop Through Ajax items");
    var imageURL = this.featured_image.url;
    var itemPrice = this.original_price;
    var handle = this.handle;
    var itemID = this.id;
    itemPrice = itemPrice / 100;
    itemPrice = formatter.format(itemPrice); //console.log(imageURL);
    /* Bind the properties */
    let itemProperties = this.properties;
    let itemPropertiesElement;
    let itemPropertiesMainElement;
    itemPropertiesElement = "<ul>";
    $.each(itemProperties, function (key, value) {
      if (key.indexOf("_") > -1) {
      } else {
        itemPropertiesElement += "<li><span>" + key + ": </span>";
        itemPropertiesElement += "<li><span>" + value + "</span>";
        itemPropertiesElement += "</li>";
        //console.log(itemPropertiesElement);
      }
    });
    itemPropertiesMainElement = itemPropertiesElement + "</ul>";
    //console.log(itemPrice);
    //console.log(itemID);
    /* check if variantTitle is NULL, then don't show variant */
    var variantTitle = this.variant_title;
    if (variantTitle == null) {
      variantTitle = "";
    }
    var lineItem;
    lineItem =
      '<li class="flex-wrap js-cart-table-item-row" data-cart-line-count=' +
      lineCount +
      ' data-handle="' +
      handle +
      '" data-variant-id=' +
      itemID +
      '><div class="image-section"> <a href="' +
      this.url +
      '"><img src="' +
      imageURL +
      '""> </a> </div>';
    lineItem +=
      '<div class="content"><h3><a href="' +
      this.url +
      '">' +
      this.product_title +
      "</a></h3><div class='cart_item_properties'>" +
      itemPropertiesElement +
      "</div>";
    lineItem += '<p class="capitalize">' + variantTitle + "</p>";
    lineItem +=
      '<div class="flex-space-between"><div class="cart-quantity-outer"> <a class="minus-qty" data-cart-line-count=' +
      lineCount +
      '" onclick="minusQuantity(' +
      lineCount +
      ')" data-variant-id=' +
      itemID +
      ' ></a> <input type="text" data-cart-line-count=' +
      lineCount +
      ' class="cart__quantity-selector" name="updates[]" value="' +
      this.quantity +
      '" maxlength="3" size="3"> <a class="plus-qty" data-cart-line-count=' +
      lineCount +
      ' onclick="plusQuantity(' +
      lineCount +
      ')" data-variant-id=' +
      itemID +
      "></a> </div>";
    lineItem +=
      "<div class='text-right'><p class='js-raw-line-item-price'>" +
      itemPrice +
      "</p>";
    lineItem +=
      '<div class="remove js-cart-item-remove" onclick="removeCartItem(this)" data-cart-remove-variant="' +
      this.id +
      '" data-cart-line-count=' +
      lineCount +
      ">Remove</div></div></div>";
    lineItem += "</li>";
    $("#CartSidebar .js-ajax-products-bind").append(lineItem);
    /* Update the Quantity and Compare Price Total for the line item if on the cart page */
    var lineItemComparePrice = $(
      ".cart-table-body[data-variant-id=" + itemID + "]"
    ).attr("data-attr-compare-price");
    lineItemComparePrice = lineItemComparePrice * this.quantity;
    lineItemComparePrice = lineItemComparePrice / 100;
    lineItemComparePrice = formatter.format(lineItemComparePrice);
    $(".cart-table-body")
      .filter('[data-variant-id="' + itemID + '"]')
      .find(".js-set-compare-price")
      .text(lineItemComparePrice);
    lineCount++;
  });
  /* Show and hide empty cart depending upon the cart items */
  setTimeout(function () {
    calculateSubTotal();
  }, 2000);
}
/* 
CALCULATE TOTAL OF THE CART
1. if you are on the cart page, then this function is being used
2. It is used to calculate the subtotal. discount, total of the cart 
*/
function calculateSubTotal() {
  let subTotal = 0;
  let discount = 0;
  let total = 0;
  let lineItemComparePrice = 0;
  let itemPrice = 0;
  let lineItemCount = 0;
  let classLineItem;
  let quantity = 0;
  if ($(".cart-table-body")[0]) {
    classLineItem = ".js-set-line-item-price";
  } else {
    classLineItem = ".js-raw-line-item-price";
  }
  /* loop through each line items on the page */
  $(classLineItem).each(function () {
    lineItemCount++;
    lineItemComparePrice = $(".js-cart-table-item-row ")
      .filter('[data-cart-line-count="' + lineItemCount + '"]')
      .attr("data-attr-compare-price");
    if (lineItemComparePrice != undefined) {
      if (lineItemComparePrice.indexOf("$") > -1) {
        lineItemComparePrice = lineItemComparePrice.replace(/[^0-9]/gi, "");
      }
    }
    lineItemComparePrice = parseInt(lineItemComparePrice);
    itemPrice = $(this)
      .text()
      .replace(/[^0-9]/gi, "");
    itemPrice = parseInt(itemPrice);
    quantity = $(".js-cart-table-item-row ")
      .filter('[data-cart-line-count="' + lineItemCount + '"]')
      .find("input[name='updates[]']")
      .val();
    quantity = parseInt(quantity);
    lineItemComparePrice = lineItemComparePrice * quantity;
    /* If the compare price is greater then 0, then the Subtotal Add Compare Price  */
    if (lineItemComparePrice > 0) {
      subTotal += lineItemComparePrice;
      /* Discount */
      discount += lineItemComparePrice - itemPrice;
    } else {
      /*This function should only run for MiniCart*/
      if (classLineItem == ".js-raw-line-item-price") {
        itemPrice = itemPrice * quantity;
      }
      subTotal += itemPrice;
    }
    total += itemPrice;
  });
  if (lineItemCount > 0) {
    subTotal = subTotal / 100;
    discount = discount / 100;
    total = total / 100;
    /* For Weird bold cases where the subtotal is greater then discount due to the complexites of the bold app
    We have to check this case and not bind the sub total and discount
    */
    let discountVisibility = false;
    if (subTotal > discount) {
      discountVisibility = true;
    }
    if (subTotal < total) {
      subTotal = total;
    }
    discount = formatter.format(discount);
    subTotal = formatter.format(subTotal);
    total = formatter.format(total);
    if (discountVisibility) {
      $(".js-cart-total-saved").html("-" + discount);
    }
    $(".js-cart-sub-total").html(subTotal);
    $(".js-cart-total").html(total);
    $(".js-ajax-cart-total strong").html("" + total);
    $(".js-ajax-cart-count").html(lineItemCount);
    $(".js-ajax-cart-total").show();
    $(".js-top-cart-form-actions").show();
  } else {
    /* 
             update cart item count = 0
             hide the totals
             hide checkout buttons
             update the icon cart with a different icon
             */
    $("#CartSidebar .js-ajax-products-bind").append(
      '<li><div class="width-100"> <p class="uppercase text-center">Your cart is empty</p> </div></li>'
    );
    $(".js-ajax-cart-count").html("0");
    $(".js-ajax-cart-total").hide();
    $(".js-top-cart-form-actions").hide();
    $(".js-show-cart-items-section").hide();
    $(".empty-cart-section").show();
    /* change the icon for the top cart, if required
                        $('.js-update-cart-icon').addClass("empty-cart");
                        */
  }
}
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/
function showCartSuccessMessage() {
  // setTimeout(getCartItemObject, 2000);
  // $('#cart-message').addClass('message-success');
  // $('#cart-message').removeClass('message-error');
  // $('#cart-message').html('Successfully added to cart!');
  // $('#cart-message').show()
  // setTimeout(function () {
  //   $('#cart-message').hide();
  // }, 2000);
}
function showCartErrorMessage() {
  // $('#cart-message').removeClass('message-success');
  // $('#cart-message').addClass('message-error');
  // $('#cart-message').html('There was a problem adding to the cart!');
  // $('#cart-message').show()
  // setTimeout(function () {
  //   $('#cart-message').hide();
  // }, 2000);
}
/*
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/
function addAddonsToTheListInMiniCart() {
  $(cartAjaxItems).each(function () {});
}
$(document).ready(function ($) {
  $(".js-addon-add-to-cart").click(function () {
    let cartSuccess = false;
    let quantity = 1;
    let addonSelectedVariantID = $(this).attr("data-attr-variantid");
    CartJS.addItem(
      addonSelectedVariantID,
      quantity,
      {},
      {
        success: function (response, textStatus, jqXHR) {
          cartSuccess = true;
          showCartSuccessMessage();
        },
        /* 
      Need to add a div to show the error if something went wrong
      */
        error: function (jqXHR, textStatus, errorThrown) {
          showCartErrorMessage;
        },
      }
    );
  });
  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js-top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler");
    // if cartAddon is null,
    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false;
      // going through the string and checking if the current addon handle = the addon
      //handle present in the string
      var cartAddons2 = cartAddons.split(",");
      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      }
      // add the new addon handle to the string
      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    }
    /* Hide the addons from the addon list, if the addon is present in the cart */
    var boolItemCartAddon = false;
    $(".js-ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle");
      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });
    if (boolItemCartAddon == true) {
      $(this).hide();
    }
  });
  /* Hide the complete section if there are no addons */
  var boolAddonExist = false;
  $(".js-top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  });
  if (boolAddonExist == false) {
    $(".js-freq-bought-products").hide();
  } else {
    $(".js-freq-bought-products").show();
  }
});